import { useSelector } from "react-redux";

import {
  getUserFamilyName,
  getUserGivenName,
  getUserNickName
} from "seneca-common/features/user/state";

export default function useGetTeacherDisplayName() {
  const nickname = useSelector(getUserNickName);
  const givenName = useSelector(getUserGivenName);
  const familyName = useSelector(getUserFamilyName);

  if (nickname) return nickname;

  let givenNameAbbreviation = "";

  if (givenName) givenNameAbbreviation += `${givenName?.charAt(0)}. `;

  return `${givenNameAbbreviation}${familyName}`;
}
